import { api } from '@creditsights/api-ui-web';

export const urlMappingUri = '/common/v1/url_mapping/redirect%3Furl%3D';
export const fetchUrlMapping = async (url: string): Promise<string | null> => {
  try {
    const resp = await api.get(`${urlMappingUri}${encodeURIComponent(url)}`);
    return resp.data?.targetUrl;
  } catch (error: any) {
    return null;
  }
};
